import React, { Component } from 'react';
import _ from 'lodash';
import Carousel from 'nuka-carousel';
import {   breakLaptop} from '../../../const';
import './Caro.css';


/**
 * Caro
 * @constructor
 * @param {prop} data - Items
 * @param {prop} respSlidesToShow - Responsive Slides to Show
 * @param {prop} slidesToShow - Slides to Show
 * @param {prop} frameOverflow - Show Overflow
 * @param {prop} data - Items
 */

class Caro extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...props,
      slidesToShow: window.innerWidth < breakLaptop ? props.respSlidesToShow : props.slidesToShow,
      slidesToScroll: window.innerWidth < breakLaptop ? 1 : props.slidesToScroll,
      slideIndex: this.props.slideIndex,
      resetIndex: false
    };

  }

  componentDidMount(){
    window.addEventListener('resize', this.onResize, false);
    this.throttledResize = _.throttle(this.throttledResize.bind(this), 500);
  }

  componentWillUnmount(){
    window.removeEventListener('resize', this.onResize, false);
  }

  /**
  * Tied to the resize event on window
  */
  onResize = (e) => {
    this.throttledResize(e);
  }
  /**
  * Throttled resize function, handles resetting slidesToShow count
  */
  throttledResize = (e) => {
    const { respSlidesToShow, slidesToShow, slidesToScroll } = this.props;
    this.setState({
      slidesToShow: window.innerWidth < breakLaptop ? respSlidesToShow : slidesToShow,
      slidesToScroll: window.innerWidth < breakLaptop ? slidesToScroll : slidesToScroll

    });
  }
  render(){
    const { slidesToShow, slidesToScroll } = this.state;
    const { frameOverflow, framePadding, insertClass, cellSpacing, color, wrapAround, slideWidth, initialSlideWidth } = this.props;
    return (
      <div className={'caro '+ insertClass +' mod-'+color}>
        <Carousel
          scrollMode='page'
          frameOverflow={''+frameOverflow+''}
          framePadding={framePadding}
          cellSpacing={cellSpacing}
          slidesToShow={slidesToShow}
          slidesToScroll={slidesToScroll}
          slideIndex={this.state.slideIndex}
          afterSlide={slideIndex => this.setState({ slideIndex })}
          width={'100%'}
          slideWidth={slideWidth}
          wrapAround={wrapAround}
          // initialSlideHeight={350}
          // wrapAround={true}
          framePadding={framePadding || '37px'}
          frameOverflow={'hidden'}
          initialSlideWidth={initialSlideWidth}
          // slideHeight='400px'
          // height='100%'
          renderCenterLeftControls={({ previousSlide }) => {
            // if(this.state.slideIndex > 0 ){
              return(
                <button
                  className='caro-transport caro-transport-prev'
                  onClick={previousSlide}>
                  <svg viewBox="0 0 39 56">
                    <title>ARROW</title>
                    <g id="Website" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                        <g id="BIO-PAGE_2" transform="translate(-1510.000000, -534.000000)" fill="#02A664" stroke="#FFFFFF" strokeWidth="2">
                            <g id="ARROW" transform="translate(1508.000000, 534.000000)">
                                <path d="M12.8913043,1.58926168 L3.58229208,10.8524662 L20.8142988,28 L3.58229208,45.1475338 L12.8917237,54.4111556 L39.4172913,27.9847196 L12.8913043,1.58926168 Z"></path>
                            </g>
                        </g>
                    </g>
                  </svg>
                </button>
              )
            // }
          }}
          renderCenterRightControls={({ nextSlide }) => {
              // if(this.state.slideIndex < this.props.children.length - 1 && (this.props.children.length > this.state.slidesToScroll)){
                return(
                  <button
                    className='caro-transport caro-transport-next'
                    onClick={nextSlide}>
                    <svg viewBox="0 0 39 56">
                      <title>ARROW</title>
                      <g id="Website" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                          <g id="BIO-PAGE_2" transform="translate(-1510.000000, -534.000000)" fill="#02A664" stroke="#FFFFFF" strokeWidth="2">
                              <g id="ARROW" transform="translate(1508.000000, 534.000000)">
                                  <path d="M12.8913043,1.58926168 L3.58229208,10.8524662 L20.8142988,28 L3.58229208,45.1475338 L12.8917237,54.4111556 L39.4172913,27.9847196 L12.8913043,1.58926168 Z"></path>
                              </g>
                          </g>
                      </g>
                    </svg>
                  </button>
                )
              // }    
          }}
          >
          { this.props.children }
        </Carousel>
      </div>
    );
  }
}

export default Caro;



// WEBPACK FOOTER //
// ./src/components/Carousels/Caro/Caro.js